InClassResults = new (function () {
  this.bindEvents = () => {
    $(".submit_in_class").click(function () {
      const data = $("#raw_subject").val();
      if (!data) return;
      const [subject, currentYear] = data.split(" - Year ");

      $("#year_group").val(currentYear);
      $("#subject").val(subject);
    });
  };

  this.setSelects = () => {
    $(".new_in_class_result_form #raw_subject").select2({
      allowClear: false,
    });
  };

  this.initForms = () => {
    wrapper = $("#upload-in-class-results");
    if (!wrapper || !wrapper.length) return;
    Shared.applyFileValidation({
      fileSelector: "#uploadInClass",
      submitSelector: "#upload-in-class-results button[type='submit']",
    });
  };
})();
